"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearHash = exports.getTokenFromHash = void 0;
/**
 * Cross-app auth handoff: one Mango app links to another with `#mango_token=<jwt>` appended
 * (see mango-shop/src/context/AuthContext.tsx for the original producer/consumer pair this
 * generalizes). The hash never reaches the server, so it's a safe way to carry a session
 * token across an origin change without putting it in the URL path/query.
 */
function getTokenFromHash() {
    if (typeof window === 'undefined' || !window.location.hash)
        return null;
    const raw = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash;
    const params = new URLSearchParams(raw);
    return params.get('mango_token');
}
exports.getTokenFromHash = getTokenFromHash;
function clearHash() {
    if (typeof window === 'undefined' || !window.location.hash)
        return;
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
}
exports.clearHash = clearHash;
